import { bundle } from '@kineticdata/react';
import {
  handleErrors,
  paramBuilder,
  headerBuilder,
} from '@kineticdata/react/lib/apis/http';
import axios from 'axios';

export const cloneSubmission = options => {
  const { id, completed = false, ...opts } = options;

  const path = `${bundle.apiLocation()}/submissions/${id}/clone`;
  const params = { ...paramBuilder(options), completed };
  const formData = new FormData();
  formData.append('submission', JSON.stringify({ ...opts }));

  return (
    axios
      .post(path, formData, { params, headers: headerBuilder(options) })
      // Remove the response envelop and leave us with the submission one.
      .then(response => ({ submission: response.data.submission }))
      // Clean up any errors we receive. Make sure this the last thing so that it
      // cleans up any errors.
      .catch(handleErrors)
  );
};

export const createFile = options => {
  const { slug, path, file } = options;

  if (!slug) {
    throw new Error('createFile failed! The option "slug" is required.');
  }
  if (!file) {
    throw new Error('createFile failed! The option "file" is required.');
  }
  if (!!path && path.endsWith(file.name)) {
    throw new Error(
      'createFile failed! The option "path" should not include the filename.',
    );
  }

  const apiPath = `${bundle.apiLocation()}/fileResources/${slug}/files${
    !!path ? '/' : ''
  }${path}`;
  const params = { ...paramBuilder(options) };
  const formData = new FormData();
  formData.append('file', file);

  return (
    axios
      .post(apiPath, formData, { params, headers: headerBuilder(options) })
      // Remove the response envelop and leave us with the data one.
      .then(response => ({ data: response.data }))
      // Clean up any errors we receive. Make sure this the last thing so that it
      // cleans up any errors.
      .catch(handleErrors)
  );
};

export const postWebApi = options => {
  const { kappSlug, slug, timeout, data, ...opts } = options;

  const path = `${bundle.contextPath()}/app${
    kappSlug ? `/kapps/${kappSlug}` : ''
  }/webApis/${slug}${
    typeof timeout !== 'undefined' ? `?timeout=${timeout}` : ''
  }`;

  return axios
    .post(path, data, {
      params: paramBuilder(opts),
      headers: headerBuilder(opts),
    })
    .then(response => ({ data: response.data }))
    .catch(handleErrors);
};
